import { Injectable, NgModule } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd';
import { HdLogComponent } from './hd-log.component';

@Injectable({
  providedIn: 'root',
})

export class HdLogService {

  constructor(private modalService: NzModalService) { }

  showLogs(logs: any[]) {
    this.modalService.create({
      nzTitle: '操作日志',
      nzContent: HdLogComponent,
      nzComponentParams: { logs },
      nzFooter: null,
      nzWidth: 1000
    });
  }
}
